function hexToHsl(hex) {
  var r = parseInt(hex.slice(1, 3), 16) / 255;
  var g = parseInt(hex.slice(3, 5), 16) / 255;
  var b = parseInt(hex.slice(5, 7), 16) / 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / d + 2) / 6;
        break;
      case b:
        h = ((r - g) / d + 4) / 6;
        break;
    }
  }
  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100),
  };
}

function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;
  var c = (1 - Math.abs(2 * l - 1)) * s;
  var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  var m = l - c / 2;
  var r = 0,
    g = 0,
    b = 0;
  if (h < 60) {
    r = c;
    g = x;
  } else if (h < 120) {
    r = x;
    g = c;
  } else if (h < 180) {
    g = c;
    b = x;
  } else if (h < 240) {
    g = x;
    b = c;
  } else if (h < 300) {
    r = x;
    b = c;
  } else {
    r = c;
    b = x;
  }
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);
  return (
    "#" +
    [r, g, b]
      .map(function (v) {
        return v.toString(16).padStart(2, "0");
      })
      .join("")
  );
}

function darken(hex, percent) {
  var hsl = hexToHsl(hex);
  hsl.l = Math.max(0, hsl.l - percent);
  return hslToHex(hsl.h, hsl.s, hsl.l);
}

function lighten(hex, percent) {
  var hsl = hexToHsl(hex);
  hsl.l = Math.min(100, hsl.l + percent);
  return hslToHex(hsl.h, hsl.s, hsl.l);
}

function withOpacity(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
}

var ALL_VARS = [
  "--company-branding-primary",
  "--company-branding-primary-hover",
  "--company-branding-primary-active",
  "--company-branding-primary-border-hover",
  "--company-branding-primary-border-active",
  "--company-branding-primary-shadow",
  "--company-branding-primary-alert-bg",
  "--company-branding-primary-alert-border",
  "--company-branding-primary-alert-color",
  "--company-branding-secondary",
  "--company-branding-secondary-hover",
  "--company-branding-secondary-active",
  "--company-branding-secondary-border-hover",
  "--company-branding-secondary-border-active",
  "--company-branding-secondary-shadow",
  "--company-branding-secondary-alert-bg",
  "--company-branding-secondary-alert-border",
  "--company-branding-secondary-alert-color",
  "--company-branding-prim-grad-1",
  "--company-branding-prim-grad-2",
  "--company-branding-sec-grad-1",
  "--company-branding-sec-grad-2",
  "--company-branding-primary-darker",
  "--company-branding-primary-shadow-color",
];

function setVar(name, value) {
  document.documentElement.style.setProperty(name, value);
}

function isAccessibleColorsActive() {
  return (
    document.body && document.body.classList.contains("a11y-accessible-colors")
  );
}

// Il blu istituzionale vecchio (#004A87) era il colore secondario di default
// della piattaforma e molte aziende lo hanno salvato senza sceglierlo: in
// ConCura vale come "nessuna scelta" e diventa il navy attuale (2026-09-07).
var LEGACY_SECONDARY_DEFAULTS = { "#004a87": "#0E2A47" };
function normalizeSecondary(hex) {
  if (!hex || process.env.VUE_APP_SCOPE !== "concura") return hex;
  return LEGACY_SECONDARY_DEFAULTS[String(hex).toLowerCase()] || hex;
}

function computeBrandingVars(primary, secondary) {
  secondary = normalizeSecondary(secondary);
  return {
    "--company-branding-primary": primary,
    "--company-branding-primary-hover": darken(primary, 7.5),
    "--company-branding-primary-active": darken(primary, 10),
    "--company-branding-primary-border-hover": darken(primary, 10),
    "--company-branding-primary-border-active": darken(primary, 12.5),
    "--company-branding-primary-shadow": withOpacity(primary, 0.25),
    "--company-branding-primary-alert-bg": lighten(primary, 40),
    "--company-branding-primary-alert-border": lighten(primary, 33),
    "--company-branding-primary-alert-color": darken(primary, 20),
    "--company-branding-secondary": secondary,
    "--company-branding-secondary-hover": darken(secondary, 7.5),
    "--company-branding-secondary-active": darken(secondary, 10),
    "--company-branding-secondary-border-hover": darken(secondary, 10),
    "--company-branding-secondary-border-active": darken(secondary, 12.5),
    "--company-branding-secondary-shadow": withOpacity(secondary, 0.25),
    "--company-branding-secondary-alert-bg": lighten(secondary, 40),
    "--company-branding-secondary-alert-border": lighten(secondary, 33),
    "--company-branding-secondary-alert-color": darken(secondary, 20),
    "--company-branding-prim-grad-1": lighten(primary, 15),
    "--company-branding-prim-grad-2": lighten(primary, 20),
    "--company-branding-sec-grad-1": darken(secondary, 15),
    "--company-branding-sec-grad-2": secondary,
    "--company-branding-primary-darker": lighten(primary, 20),
    "--company-branding-primary-shadow-color": withOpacity(primary, 0.2),
  };
}

function applyCompanyBranding(primary, secondary) {
  if (isAccessibleColorsActive()) {
    resetCompanyBranding();
    return false;
  }

  secondary = normalizeSecondary(secondary);
  document.body.classList.add("branding-active");
  setVar("--company-branding-primary", primary);
  setVar("--company-branding-primary-hover", darken(primary, 7.5));
  setVar("--company-branding-primary-active", darken(primary, 10));
  setVar("--company-branding-primary-border-hover", darken(primary, 10));
  setVar("--company-branding-primary-border-active", darken(primary, 12.5));
  setVar("--company-branding-primary-shadow", withOpacity(primary, 0.25));
  setVar("--company-branding-primary-alert-bg", lighten(primary, 40));
  setVar("--company-branding-primary-alert-border", lighten(primary, 33));
  setVar("--company-branding-primary-alert-color", darken(primary, 20));

  setVar("--company-branding-secondary", secondary);
  setVar("--company-branding-secondary-hover", darken(secondary, 7.5));
  setVar("--company-branding-secondary-active", darken(secondary, 10));
  setVar("--company-branding-secondary-border-hover", darken(secondary, 10));
  setVar("--company-branding-secondary-border-active", darken(secondary, 12.5));
  setVar("--company-branding-secondary-shadow", withOpacity(secondary, 0.25));
  setVar("--company-branding-secondary-alert-bg", lighten(secondary, 40));
  setVar("--company-branding-secondary-alert-border", lighten(secondary, 33));
  setVar("--company-branding-secondary-alert-color", darken(secondary, 20));

  setVar("--company-branding-prim-grad-1", lighten(primary, 15));
  setVar("--company-branding-prim-grad-2", lighten(primary, 20));
  setVar("--company-branding-sec-grad-1", darken(secondary, 15));
  setVar("--company-branding-sec-grad-2", secondary);
  setVar("--company-branding-primary-darker", lighten(primary, 20));
  setVar("--company-branding-primary-shadow-color", withOpacity(primary, 0.2));

  return true;
}

function resetCompanyBranding() {
  document.body.classList.remove("branding-active");
  ALL_VARS.forEach(function (v) {
    document.documentElement.style.removeProperty(v);
  });
}

var STORAGE_KEY = "company_branding";
var BANNER_STORAGE_KEY = "company_branding_banner";
var BANNER_EVENT = "company-branding-banner-updated";

function getBrandingFromStorage() {
  try {
    var stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
}

function hasBrandingChanged(primary, secondary) {
  var stored = getBrandingFromStorage();
  if (!stored) {
    return true;
  }
  return (
    stored.primary_color !== primary || stored.secondary_color !== secondary
  );
}

function getBannerFromStorage() {
  try {
    return localStorage.getItem(BANNER_STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
}

function hasBannerChanged(bannerUrl) {
  return getBannerFromStorage() !== (bannerUrl || null);
}

function notifyBannerChange(bannerUrl) {
  window.dispatchEvent(
    new CustomEvent(BANNER_EVENT, {
      detail: { bannerUrl: bannerUrl || null },
    })
  );
}

function saveBrandingToStorage(primary, secondary) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ primary_color: primary, secondary_color: secondary })
  );
}

function saveBannerToStorage(bannerUrl) {
  if (bannerUrl) {
    localStorage.setItem(BANNER_STORAGE_KEY, bannerUrl);
  } else {
    localStorage.removeItem(BANNER_STORAGE_KEY);
  }
  notifyBannerChange(bannerUrl);
}

function loadBannerFromStorage() {
  return getBannerFromStorage();
}

function clearBannerStorage() {
  localStorage.removeItem(BANNER_STORAGE_KEY);
  notifyBannerChange(null);
}

function loadBrandingFromStorage() {
  try {
    var data = getBrandingFromStorage();
    if (data && data.primary_color && data.secondary_color) {
      applyCompanyBranding(data.primary_color, data.secondary_color);
      return true;
    }
  } catch (e) {
    // storage non disponibile o dati corrotti
  }
  return false;
}

function clearBrandingStorage() {
  localStorage.removeItem(STORAGE_KEY);
  clearBannerStorage();
}

export {
  applyCompanyBranding,
  resetCompanyBranding,
  getBrandingFromStorage,
  hasBrandingChanged,
  getBannerFromStorage,
  hasBannerChanged,
  saveBrandingToStorage,
  loadBrandingFromStorage,
  clearBrandingStorage,
  computeBrandingVars,
  saveBannerToStorage,
  loadBannerFromStorage,
  clearBannerStorage,
  BANNER_EVENT,
};
